module.exports = __webpack_public_path__ + "static/media/HalfHeadSnappy.b59d0adf.svg";